module.exports = __webpack_public_path__ + "static/media/image-mask.35cdbe4e.svg";